import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section id="featured" className="w-full bg-background-100 py-10 md:py-14">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选文章</h2>
            <p className="mt-2 text-sm text-foreground-600">编辑团队精心挑选的优质内容</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-colors hover:bg-accent-50/50"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    {article.category === 'keji' ? '科技' :
                     article.category === 'shenghuo' ? '生活' :
                     article.category === 'yule' ? '娱乐' :
                     article.category === 'caijing' ? '财经' :
                     article.category === 'jiaoyu' ? '教育' : '健康'}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                      <img src={article.authorAvatar} alt={article.author} className="w-full h-full object-cover" />
                    </div>
                    <span className="text-xs text-foreground-500">{article.author}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}